import { Provider } from "react-redux";
import { Route, Routes } from "react-router";

import { store } from "./store/store";
import Home from "./pages/Home";
import Quiz from "./pages/Quiz";
import Rank from "./pages/Rank";
import PokemonQuizResult from "./components/PokemonQuiz/PokemonQuizResult";
import Layout from "./components/Layout";

const App = () => {
  return (
    <Provider store={store}>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/quiz" element={<Quiz />} />
          <Route path="/quiz/result" element={<PokemonQuizResult />} />
          <Route path="/rank" element={<Rank />} />
        </Routes>
      </Layout>
    </Provider>
  );
};

export default App;
